
export const JWT_TOKEN = 'jwt';
export const JWT_TOKEN_IAT = 'jwt_iat';
export const JWT_TOKEN_ORIG_IAT = 'jwt_orig_iat';

export const TOKEN_REFRESH_RATE = 10 * 60 * 1000; // token should be refreshed after 10 minutes
export const TOKEN_EXPIRATION_DELTA =  48 * 3600 * 1000; // token will expire after 48 hours
export const TOKEN_REFRESH_EXPIRATION = 7 * 24 * 3600 * 1000; // token can be refreshed for 7 days
export const TURNSTILE_SITE_KEY = "0x4AAAAAAAznIp77eM2wdBO_";
